import {FACTIONS} from "../../../constants/factions";

export const MUSHROOM_PEOPLE_QUOTES = [{
  quote: 'Мы не строим стены. Мы выращиваем их из костей тех, кто слишком долго стоял на месте',
  author: 'Склероций Спящий, гриболюд-архитектор Города-на-Костях',
  factionId: FACTIONS.MUSHROOM_PEOPLE
}, {
  quote: 'Чем дольше ты рядом с нами, тем медленнее твой меч поднимается. Ты думаешь — это усталость. Нет, это наша любовь',
  author: 'Ксиларий Твердый, гриболюд-командующий Серой долины',
  factionId: FACTIONS.MUSHROOM_PEOPLE
}, {
  quote: 'Одна спора — обещание. Тысяча — город. Миллион — конец твоего королевства',
  author: 'Мицелла Спара, мать-гриболюд подземной грибницы Ульфрима',
  factionId: FACTIONS.MUSHROOM_PEOPLE
}, {
  quote: 'Умрёшь ты быстро. А вот гниль, которая вырастет на тебе, будет жить вечно',
  author: 'Гифций Разрастающий, гриболюд-строитель споровой крепости Брак-Сорм',
  factionId: FACTIONS.MUSHROOM_PEOPLE
}, {
  quote: 'Нам не нужно золото. Нам нужны только ваши мёртвые — и немного сырости',
  author: 'Дакрил Ползучий, гриболюд-расширитель мицелиальных сетей',
  factionId: FACTIONS.MUSHROOM_PEOPLE
}, {
  quote: 'Каждый шаг по нашей земле — это вдох наших спор. Каждый вдох — это зародыш новой жизни. Внутри тебя',
  author: 'Сапрофий Пожиратель, гриболюд-надзиратель Гниющей плоти',
  factionId: FACTIONS.MUSHROOM_PEOPLE
}, {
  quote: 'Спора не знает, куда летит. Но она всегда находит цель',
  author: 'Трутовий Гнилец, токсичный гриболюд-разносчик',
  factionId: FACTIONS.MUSHROOM_PEOPLE
}]